module.exports = __webpack_public_path__ + "img/logo.ee4203f1.png";